<template>
  <ul class="list-group list-group-flush">
    <li v-for="(item, index) in currencies" :key="index" class="list-group-item list-group-item-action" style="cursor: pointer" @click="changeCurrency(item)" data-bs-dismiss="modal">
      {{ item }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "Currencies",
  data() {
    return {
      currencies: [
          "USD",
          "EUR",
          "GBP",
          "AUD",
          "CAD",
          "CHF",
          "CNY",
          "JPY",
          "NZD",
          "MXN",
          "BRL",
          "ARS",
          "SGD",
          "CLP",
          "RUB",
          "HKD",
          "SEK",
          "DKK",
          "NOK",
      ]
    }
  },
  methods: {
    changeCurrency(code) {
      localStorage.setItem('currency', code);
      this.$emit('change-currency', code);
      const event = new CustomEvent('update-results', { detail: { currency: code } });
      window.dispatchEvent(event);
    }
  }
}
</script>

<style scoped>

</style>
